import {
  CamActivityDashboard,
  CamAddEditBilledForPeriod,
  CamAddEditBillingConfig,
  CamAddEditBillingLog,
  CamAddEditCashApp,
  CamAddEditClearing,
  CamAddEditInvoice,
  CamAddEditJournalEntry,
  CamAddEditLineItem,
  CamAddEditPayment,
  CamAddEditPendingPosting,
  CamAR360Report,
  CamAuditTrail,
  CamAuditTrailView,
  CamBilledForPeriodListing,
  CamBillingConfig,
  CamBillingLogs,
  CamCashAppList,
  CamClearingListing,
  CamCloseoutReport,
  CamCostTrialBalance,
  CamDisplayAccountingDocument,
  CamDistributionMetricsMaintenance,
  CamDistributionRuleConfiguration,
  CamDistributionRunTimeDetails,
  CamFiscalYearClosing,
  CamFiscalYearLifecycle,
  CamFixedWeight,
  CamGLConfigurationStudio,
  CamInvoiceListing,
  CamJournalEntryList,
  CamLineItems,
  CamOwnerTrialBalance,
  CamPayment360InvoiceListing,
  CamPayment360Report,
  CamPaymentListing,
  CamPendingPostingListing,
  CamReconciliationReport,
  CamReportByOwner,
  CamReportByVendor,
  CamReports,
  CamToleranceReport,
  CamTraceabilityReport,
  CamTrialBalance,
  CamVendorTrialBalance,
  CamViewJobDetails,
  CamViewJobGlDetails,
  CamWeighingFactor,
  CamWeighingFactorDetailedView,
} from "@/pages";
import { routes } from "../utils";
import { PermissionGuard } from "@/components";
import { actionsKeys } from "@/lib/utils";

export const ActivityDashboardRoutes = () => {
  return {
    path: routes.activityDashboard,
    children: [
      {
        path: "",
        element: <CamActivityDashboard />,
      },
      {
        path: routes.invoice + "/" + routes.add,
        element: 
          <PermissionGuard moduleKey={actionsKeys.INVOICE} action={routes.add}>
            <CamAddEditInvoice />
          </PermissionGuard>,
      },
      {
        path: routes.invoice + "/" + routes.invoiceAction,
        element: 
          <PermissionGuard moduleKey={actionsKeys.INVOICE}>
            <CamInvoiceListing />
          </PermissionGuard>
      },
      {
        path:
          routes.invoice +
          "/" +
          routes.invoiceAction +
          "/" +
          routes.invoiceId +
          "/" +
          routes.action,
        element: 
          <PermissionGuard moduleKey={actionsKeys.INVOICE}>
            <CamAddEditInvoice />,
          </PermissionGuard>
      },
      {
        path: routes.payment + "/" + routes.add,
        element: 
          <PermissionGuard moduleKey={actionsKeys.PAYMENT} action={routes.add}>
            <CamAddEditPayment />,
          </PermissionGuard>
      },
      {
        path: routes.payment + "/" + routes.paymentAction,
        element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
            <CamPaymentListing />
          </PermissionGuard>,
      },
      {
        path:
          routes.payment +
          "/" +
          routes.paymentAction +
          "/" +
          routes.paymentId +
          "/" +
          routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
          <CamAddEditPayment />
        </PermissionGuard>,
      },
      {
        path: routes.payment + "/" + routes.reports,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.PAYMENT_REPORT}>
              <CamPayment360Report />
            </PermissionGuard>,
          },
          {
            path: routes.glId + "/" + routes.month,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.PAYMENT_REPORT}>
                    <CamPayment360InvoiceListing />
                  </PermissionGuard>
              },
              {
                path: routes.invoiceId + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.INVOICE}>
                    <CamAddEditInvoice />
                  </PermissionGuard>,
              },
            ],
          },
          {
            path:
              routes.glId +
              "/" +
              routes.month +
              "/" +
              routes.listing +
              "/" +
              routes.paymentAction,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                    <CamPaymentListing />
                </PermissionGuard>
              },
              {
                path: routes.paymentId + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                    <CamAddEditPayment />
                </PermissionGuard>
              },
            ],
          },
        ],
      },
      {
        path: routes.payment + "/" + routes.tolerance,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.TOLERANCE_REPORT}>
                <CamToleranceReport />
            </PermissionGuard>,
          },
          {
            path:
              routes.budgetMgmt +
              "/" +
              routes.budgetId +
              "/" +
              routes.lineItems,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.TOLERANCE_REPORT}>
                    <CamLineItems />
                </PermissionGuard>
              },
              {
                path: routes.lineItemId + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.TOLERANCE_REPORT}>
                    <CamAddEditLineItem />
                  </PermissionGuard>
              },
            ],
          },
        ],
      },
      {
        path: routes.billingConfig,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_CONFIG}>
          <CamBillingConfig />
        </PermissionGuard>
      },
      {
        path: routes.billingConfig + "/" + routes.add,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_CONFIG} action={routes.add}>
            <CamAddEditBillingConfig />
          </PermissionGuard>
      },
      {
        path:
          routes.billingConfig + "/" + routes.billingId + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_CONFIG}>
          <CamAddEditBillingConfig />
        </PermissionGuard>
      },
      {
        path: routes.pendingPosting,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
            <CamPendingPostingListing />
          </PermissionGuard>
      },
      {
        path:
          routes.pendingPosting + "/" + routes.billingId + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
            <CamAddEditPendingPosting />
          </PermissionGuard>
      },
      {
        path: routes.billedForPeriod,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
            <CamBilledForPeriodListing />
          </PermissionGuard>
      },
      {
        path:
          routes.billedForPeriod + "/" + routes.billingId + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
            <CamAddEditBilledForPeriod />
          </PermissionGuard>,
      },
      {
        path: routes.billingLog,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_LOGS}>
            <CamBillingLogs />
          </PermissionGuard>
      },
      {
        path: routes.billingLog + "/" + routes.billingId + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.BILLING_LOGS}>
            <CamAddEditBillingLog />
          </PermissionGuard>
      },
      {
        path: routes.journalEntry,
        element: <PermissionGuard moduleKey={actionsKeys.UNIFIED_JE}>
            <CamJournalEntryList />
          </PermissionGuard>
      },
      {
        path: routes.journalEntry + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.UNIFIED_JE}>
            <CamAddEditJournalEntry />
          </PermissionGuard>
      },
      {
        path:
          routes.journalEntry + "/" + routes.billingId + "/" + routes.action,
        element: <PermissionGuard moduleKey={actionsKeys.UNIFIED_JE}>
            <CamAddEditJournalEntry />
          </PermissionGuard>
      },
      {
        path: routes.invoiceReports,
        element: <PermissionGuard moduleKey={actionsKeys.INVOICE_REPORT}>
            <CamReports />
          </PermissionGuard>
      },
      {
        path: routes.cashApp,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.CASH_APP}>
                <CamCashAppList />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.CASH_APP} action={routes.add}>
                <CamAddEditCashApp />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.status + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.CASH_APP}>
              <CamAddEditCashApp />
            </PermissionGuard>
          },
        ],
      },
      {
        path: routes.clearing,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.MANUAL_CLEARING}>
                <CamClearingListing />
              </PermissionGuard>,
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.MANUAL_CLEARING} action={routes.add}>
                <CamAddEditClearing />
              </PermissionGuard>
          },
          {
            path: routes.clearingId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.MANUAL_CLEARING}>
                <CamAddEditClearing />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.ar360,
        element: <PermissionGuard moduleKey={actionsKeys.COLLECTION_REPORT}>
            <CamAR360Report />
          </PermissionGuard>
      },
      {
        path: routes.fiscalYearClosing,
        element: <PermissionGuard moduleKey={actionsKeys.FISCAL_YEAR}>
            <CamFiscalYearClosing />
          </PermissionGuard>
      },
      {
        path: routes.fiscalYearLifeCycle,
        element: <PermissionGuard moduleKey={actionsKeys.FISCAL_YEAR}>
            <CamFiscalYearLifecycle />
          </PermissionGuard>,
      },
      {
        path: routes.trialBalance,
        element: <PermissionGuard moduleKey={actionsKeys.GL_TRIAL_BALANCE}>
            <CamTrialBalance />
          </PermissionGuard>
      },
      {
        path: routes.displayAccountingDocument,
        element: <PermissionGuard moduleKey={actionsKeys.DISPLAY_ACCOUNTING_DOCUMENT}>
            <CamDisplayAccountingDocument />
          </PermissionGuard>
      },
      {
        path: routes.vendorTrialBalance,
        element: <PermissionGuard moduleKey={actionsKeys.VENDOR_TRIAL_BALANCE}>
            <CamVendorTrialBalance />
          </PermissionGuard>,
      },
      {
        path: routes.ownerTrialBalance,
        element: <PermissionGuard moduleKey={actionsKeys.OWNER_TRIAL_BALANCE}>
            <CamOwnerTrialBalance />
          </PermissionGuard>,
      },
      {
        path: routes.auditTrail,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.AUDIT_TRAIL}>
                <CamAuditTrail />
              </PermissionGuard>,
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.AUDIT_TRAIL}>
                <CamAuditTrailView />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.glConfigurationStudio,
        element: <PermissionGuard moduleKey={actionsKeys.GL_CONFIG}>
            <CamGLConfigurationStudio />
          </PermissionGuard>
      },
      // {
      //   path: routes.createJEManual,
      //   element: <PermissionGuard moduleKey={actionsKeys.MANUAL_JE} action={routes.add}>
      //       <CamCreateJEManual />
      //     </PermissionGuard>
      // },
      // {
      //   path: routes.jeManual + "/" + routes.status,
      //   children: [
      //     {
      //       path: "",
      //       element: <PermissionGuard moduleKey={actionsKeys.MANUAL_JE}>
      //           <CamParkedPostedJEListing />
      //         </PermissionGuard>
      //     },
      //     {
      //       path: routes.id + "/" + routes.action,
      //       element: <PermissionGuard moduleKey={actionsKeys.MANUAL_JE}>
      //           <CamJEDetails />
      //         </PermissionGuard>
      //     },
      //   ],
      // },
      {
        path: routes.distributionMetricsMaintenance,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamDistributionMetricsMaintenance />
              </PermissionGuard>,
          },
          {
            path: routes.weighingFactor + "/" + routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamWeighingFactorDetailedView />
              </PermissionGuard>,
          }
        ]
      },
      {
        path: routes.distributionRuntimeDetails,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamDistributionRunTimeDetails />
              </PermissionGuard>
          },
          {
            path: routes.id,
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamViewJobDetails />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.glId,
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamViewJobGlDetails />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.distributionRuleConfiguration,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamDistributionRuleConfiguration />
              </PermissionGuard>
          },
          {
            path: routes.fixedWeight + "/" + routes.level + "/" + routes.type + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                <CamFixedWeight />
              </PermissionGuard>
          },
          {
            path: routes.weighingFactor + "/" + routes.type,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <CamWeighingFactor />
                  </PermissionGuard>
              },
              {
                path: routes.id + "/" + routes.details,
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                  <CamWeighingFactorDetailedView />
                </PermissionGuard>
              }
            ]
          }
        ]
      },
      {
        path: routes.traceability,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_REPORT}>
                <CamTraceabilityReport />
              </PermissionGuard>
          },
          {
            path: `${routes.distributionRuleConfiguration}/${routes.glId}`,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_REPORT}>
                    <CamDistributionRuleConfiguration />
                  </PermissionGuard>
              },
              {
                path: routes.fixedWeight + "/" + routes.level + "/" + routes.type + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_REPORT}>
                    <CamFixedWeight />
                  </PermissionGuard>
              },
              {
                path: routes.weighingFactor + "/" + routes.type,
                children: [
                  {
                    path: "",
                    element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_REPORT}>
                        <CamWeighingFactor />
                      </PermissionGuard>
                  },
                  {
                    path: routes.id + "/" + routes.details,
                    element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_REPORT}>
                        <CamWeighingFactorDetailedView />
                      </PermissionGuard>
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        path: routes.reconciliation,
        element: <PermissionGuard moduleKey={actionsKeys.RECONCILIATION_REPORT}>
            <CamReconciliationReport />
          </PermissionGuard>
      },
      {
        path: routes.closeout,
        element: <PermissionGuard moduleKey={actionsKeys.CLOSEOUT_BALANCE}>
            <CamCloseoutReport />
          </PermissionGuard>
      },
      {
        path: routes.reportByOwner,
        element: <PermissionGuard moduleKey={actionsKeys.OWNER_BALANCE_REPORT}>
            <CamReportByOwner />
          </PermissionGuard>
      },
      {
        path: routes.reportByVendor,
        element: <PermissionGuard moduleKey={actionsKeys.VENDOR_BALANCE_REPORT}>
            <CamReportByVendor />
          </PermissionGuard>
      },
      {
        path: routes.vendorTrialBalance,
        element: <PermissionGuard moduleKey={actionsKeys.VENDOR_TRIAL_BALANCE}>
            <CamVendorTrialBalance />
          </PermissionGuard>
      },
      {
        path: routes.ownerTrialBalance,
        element: <PermissionGuard moduleKey={actionsKeys.OWNER_TRIAL_BALANCE}>
            <CamOwnerTrialBalance />
          </PermissionGuard>,
      },
      {
        path: routes.costTrialBalance,
        element: <PermissionGuard moduleKey={actionsKeys.COST_ANALYTICS_TRIAL_BALANCE}>
            <CamCostTrialBalance />
          </PermissionGuard>
      },
    ],
  };
};
